import { Navigate, Route, Routes } from 'react-router';
import { useSession } from '@/lib/session';
import Login from '@/pages/Login';
import Home from '@/pages/Home';
import Catalogue from '@/pages/Catalogue';
import NouvelleCommande from '@/pages/NouvelleCommande';
import Commande from '@/pages/Commande';
import AdminLayout from '@/pages/admin/AdminLayout';
import Dashboard from '@/pages/admin/Dashboard';
import Imports from '@/pages/admin/Imports';
import Export from '@/pages/admin/Export';
import Lines from '@/pages/admin/Lines';
import Promotions from '@/pages/admin/Promotions';
import Reps from '@/pages/admin/Reps';

export default function App() {
  const { session, isLoading, isError } = useSession();

  if (isLoading) {
    return (
      <div className="text-muted-foreground flex min-h-full items-center justify-center">
        Chargement…
      </div>
    );
  }

  if (isError) {
    return (
      <div className="flex min-h-full flex-col items-center justify-center gap-3 p-8 text-center">
        <p className="text-destructive font-medium">Serveur injoignable.</p>
        <p className="text-muted-foreground text-sm">
          Vérifiez la connexion réseau, puis rechargez la page.
        </p>
      </div>
    );
  }

  if (!session) return <Login />;

  const isAdmin = session.user.role === 'ADMIN';

  return (
    <Routes>
      <Route path="/" element={<Home session={session} />} />
      <Route path="/catalogue" element={<Catalogue session={session} />} />
      <Route path="/order/new" element={<NouvelleCommande />} />
      <Route path="/order/:id" element={<Commande />} />

      {/* Garde côté client pour le confort. La vraie garde est sur /api/admin. */}
      {isAdmin && (
        <Route path="/admin" element={<AdminLayout session={session} />}>
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="imports" element={<Imports />} />
          <Route path="lines" element={<Lines />} />
          <Route path="promotions" element={<Promotions />} />
          <Route path="reps" element={<Reps />} />
          <Route path="export" element={<Export />} />
        </Route>
      )}

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
